import { render } from "./EventsCalendar.vue?vue&type=template&id=4ae2f045&scoped=true"
import script from "./EventsCalendar.vue?vue&type=script&lang=js"
export * from "./EventsCalendar.vue?vue&type=script&lang=js"

import "./EventsCalendar.vue?vue&type=style&index=0&id=4ae2f045&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae2f045"]])

export default __exports__